import type { ArcualAccountProfile } from '@arcual/lib-app-platform';

export const defaultAccount = (): ArcualAccountProfile => ({
  id: '',
  name: '',
  email: '',
  imageUrl: '',
  phoneNumber: '',
  address: {
    street: '',
    secondAddressLine: '',
    houseNumber: '',
    flat: '',
    zip: '',
    city: '',
    state: '',
    country: '',
  },
  bio: '',
  termsConditionsAccepted: false,
  privacyPolicyAccepted: false,
});
